import makeStyles from '@mui/styles/makeStyles';

export default makeStyles((theme) => ({
  dialog: {
    '& .MuiDialog-paperScrollPaper': {
      backgroundColor: '#efefef',
    },

    '@media print': {
      position: 'relative !important',
      backgroundColor: 'white',

      display: 'block',
      '& .MuiBackdrop-root': {
        display: 'none',
      },
      '& .MuiDialog-scrollPaper': {
        display: 'block',
      },
      '& .MuiDialog-paperScrollPaper': {
        display: 'block',
        height: 'auto !important',
        backgroundColor: 'white',
      },
    },
  },
  fauxPage: {
    margin: '20px auto',
    maxWidth: 1000,
    width: '100%',
    padding: theme.spacing(2),
    boxShadow: '10px 10px 20px rgba(0,0,0,0.5)',
    backgroundColor: 'white',
    // pointerEvents: 'none',

    '@media print': {
      margin: 0,
      maxWidth: '100%',
      padding: 0,
      boxShadow: 'none',
    },
  },
  contents: {},
  title: {
    fontSize: 20,
    fontWeight: 'bold',
    marginBottom: 10,
  },
  coverTitle: {
    fontSize: 16,
  },
  itemTitle: {
    fontSize: 18,
  },
  buttonContainerFixed: {
    position: 'fixed !important',
  },
  buttonContainer: {
    position: 'absolute',
    top: 10,
    right: 10,
    zIndex: 100,

    [theme.breakpoints.up('xs')]: {
      top: 75,
    },
    [theme.breakpoints.down('sm')]: {
      top: 65,
    },

    '& button': {
      marginLeft: theme.spacing(1),
    },

    '@media print': {
      display: 'none',
    },
  },
  extraButton: {},
  pagebreakfirst: {
    position: 'relative',
    width: '100%',
    display: 'block',
    clear: 'both',
    pageBreakInside: 'avoid !important',

    '@media print': {
      marginBottom: 0,
    },
  },
  pagebreak: {
    position: 'relative',
    pageBreakBefore: 'always',
    width: '100%',
    display: 'block',
    clear: 'both',
    pageBreakInside: 'avoid !important',

    '@media print': {
      marginBottom: 0,
    },
  },
  sectionToggles: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: 'white',
    borderRadius: 4,
    padding: '4px 8px',
    marginTop: theme.spacing(1),
    boxShadow: '2px 2px 6px rgba(0,0,0,0.2)',

    '@media print': {
      display: 'none',
    },
  },
  sectionToggleLabel: {
    '& .MuiFormControlLabel-label': {
      fontSize: 13,
    },
    '& .MuiCheckbox-root': {
      padding: '2px 4px',
    },
  },
}));
